import React from 'react';
import classNames from 'classnames';
import { CircleButton, FlexRow } from '../../atoms';
import { Media, SubmissionMedia } from '../../graphql-operations';

export const DeleteMedia = ({
  mediaItem,
  onDelete,
  isAudio,
}: {
  mediaItem: Media | SubmissionMedia;
  onDelete?: (params: { mediaItem: Media | SubmissionMedia }) => void;
  isAudio: boolean;
}) => {
  return (
    <FlexRow
      className="cn_absolute"
      justifyContent="end"
      w="full"
      bottom={isAudio ? 0.8 : 0.5}
      right={0.5}
      data-testid="delete-media"
    >
      <CircleButton
        variant="secondary"
        icon="trash"
        label="delete"
        onClick={() => onDelete({ mediaItem })}
        className={classNames(!isAudio && 'cn_shadow-md')}
      />
    </FlexRow>
  );
};
